import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import { Select, Flex } from '@applyboard/crystal-ui';
import React from 'react';
import { format } from 'date-fns';
import { convertTimelessDateStrToLocalDate } from "../../utils/dates";
import orderBy from 'lodash/orderBy';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var INTAKE_STATUS_LABEL_MAP = {
  open: 'Open',
  likely_open: 'Likely open',
  closed: 'Closed',
  will_open: 'Will open'
};
export function IntakeStep(_ref) {
  var _state$context$select;
  var state = _ref.state,
    dispatch = _ref.dispatch;
  var intakes = state.context.intakes || [];
  var sortedIntakes = orderBy(intakes, function (intake) {
    return new Date(intake.startDate).getTime();
  }, ['asc']);
  var options = sortedIntakes.map(function (intake) {
    var formattedStartDate = format(convertTimelessDateStrToLocalDate(intake.startDate), 'LLL yyyy');
    var intakeStatus = INTAKE_STATUS_LABEL_MAP[(intake === null || intake === void 0 ? void 0 : intake.intakeStatus) || ''] || intake.intakeStatus;
    return {
      label: "".concat(formattedStartDate, "\u30FB").concat(intakeStatus),
      value: intake.intakeId
    };
  });
  return _jsx(Flex, {
    gap: 4,
    pt: 4,
    direction: "column",
    children: _jsx(Select, {
      label: "Please select an academic intake:",
      appearance: "styled",
      value: ((_state$context$select = state.context.selectedIntake) === null || _state$context$select === void 0 ? void 0 : _state$context$select.intakeId) || '',
      onChange: function onChange(intakeId) {
        var intake = intakes === null || intakes === void 0 ? void 0 : intakes.find(function (item) {
          return item.intakeId === intakeId;
        });
        if (!intake) {
          var _state$context$select2;
          if ((_state$context$select2 = state.context.selectedIntake) !== null && _state$context$select2 !== void 0 && _state$context$select2.intakeId) {
            dispatch({
              type: 'DESELECTED_INTAKE'
            });
          }
          return;
        }
        dispatch({
          type: 'SELECTED_INTAKE',
          intake: intake
        });
      },
      invalid: state.value === 'missing_intake',
      helpText: state.value === 'missing_intake' ? 'Please select an intake' : undefined,
      children: options.map(function (intake) {
        return _jsx(Select.Option, {
          label: intake.label,
          value: intake.value
        }, intake.value);
      })
    })
  });
}